// Menus show only on "on". Routes hold on "loading", render on "error" (fail open) and redirect on "off".
export type Gate = "on" | "off" | "loading" | "error"

// A known "off" settles it; "loading" beats "error" so a route keeps holding rather than failing open early.
export function allOf(...gates: Gate[]): Gate {
  if (gates.includes("off")) return "off"
  if (gates.includes("loading")) return "loading"
  if (gates.includes("error")) return "error"
  return "on"
}

export function anyOf(...gates: Gate[]): Gate {
  if (gates.includes("on")) return "on"
  if (gates.includes("loading")) return "loading"
  if (gates.includes("error")) return "error"
  return "off"
}

export function fromBoolean(value: boolean): Gate {
  return value ? "on" : "off"
}
